import axios from 'axios';

export const setToken = (token) => {
  localStorage.setItem('token', token);
};

export const setRefreshToken = (token) => {
  localStorage.setItem('refreshToken', token);
};

export const getRefreshToken = () => localStorage.getItem('refreshToken');

axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
export const getToken = () => localStorage.getItem('token');